import { render } from "./IconHome.vue?vue&type=template&id=53755eb6"
import script from "./IconHome.vue?vue&type=script&lang=js"
export * from "./IconHome.vue?vue&type=script&lang=js"

import exportComponent from "/Users/animatik/Sites/Vitalhit/Pay/id/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__